module.exports = __webpack_public_path__ + "img/smart-plug.562ece3d.svg";